import React from 'react';
import {
  BackgroundColorSystemProp,
  Box,
  SystemPropType,
} from '@leagueplatform/genesis-commons';
import { ErrorState } from '@leagueplatform/web-common-components';
import { handleStaticAsset } from '@leagueplatform/asset-config';
import {
  ERROR_TYPES,
  useErrorMessage,
} from '../../hooks/use-error-message.hook';

export interface ErrorPageProps {
  errorType: ERROR_TYPES;
}

export const FullScreenContainer = ({
  backgroundColor,
  children,
  labelledbyId,
  describedbyId,
}: {
  backgroundColor: SystemPropType<BackgroundColorSystemProp>;
  children: React.ReactNode;
  labelledbyId?: string;
  describedbyId?: string;
}) => (
  <Box
    role="dialog"
    width="100vw"
    height="100vh"
    position="fixed"
    inset="0"
    insetInlineStart="0"
    zIndex="100"
    backgroundColor={backgroundColor}
    aria-labelledby={labelledbyId}
    aria-describedby={describedbyId}
  >
    {children}
  </Box>
);

const LabelledbyId = 'full-page-error-heading';
const describedbyId = 'full-page-error-desc';

export const ErrorPage = ({ errorType }: ErrorPageProps) => {
  const { headingString, bodyString, buttonText, onButtonClick, hideButton } =
    useErrorMessage(errorType);

  const imageSrc = handleStaticAsset('ERROR_STATE_COVER') as string;
  return (
    <FullScreenContainer
      labelledbyId={LabelledbyId}
      describedbyId={describedbyId}
      backgroundColor="surface.background.primary"
    >
      <Box
        position="fixed"
        top="50%"
        insetInlineStart="50%"
        transform="translate(-50%, -50%)"
      >
        <ErrorState
          imageSrc={imageSrc}
          headingString={headingString}
          bodyString={bodyString}
          buttonText={buttonText}
          hideButton={hideButton}
          onButtonClick={onButtonClick}
          labelledbyId={LabelledbyId}
          describedbyId={describedbyId}
          error={null}
        />
      </Box>
    </FullScreenContainer>
  );
};
